import { useLayoutEffect } from "react";

/**
 * Keeps full-page / section loading spinners in view when fetch starts (scroll position was low).
 */
export function useScrollToTopWhenLoading(loading) {
  useLayoutEffect(() => {
    if (!loading) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [loading]);
}
